import { render, staticRenderFns } from "./DetailSettingsTab.vue?vue&type=template&id=dcbd3628"
import script from "./DetailSettingsTab.vue?vue&type=script&lang=ts"
export * from "./DetailSettingsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcbd3628')) {
      api.createRecord('dcbd3628', component.options)
    } else {
      api.reload('dcbd3628', component.options)
    }
    module.hot.accept("./DetailSettingsTab.vue?vue&type=template&id=dcbd3628", function () {
      api.rerender('dcbd3628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/DetailSettingsTab.vue"
export default component.exports